
import "./popupQuitter.scss";

import { Component } from "react";
import PopupManager from "../PopupManager";

interface IPopupQuitterProps{
    pm:PopupManager
}
type IPopupQuitterState = {
    
    
}

class PopupQuitter extends Component<IPopupQuitterProps,IPopupQuitterState> {

  pm:PopupManager;    
  
  constructor(props:any){
    super(props);
    this.state = this.getInitialState();
    this.pm = props.pm;
  }
  getInitialState():IPopupQuitterState{
    return{}
  }


  componentDidMount(){ 
    
  }

  
  render() {    
    return (
        <div className="popup quitter">
            <div className="contenu" dangerouslySetInnerHTML={{__html:(this.pm.app.donneesLaby) ? this.pm.app.donneesLaby.textes.popup_quitter : "Texte manquant."}}></div>
            <div className="btn_choix">
              <button className="non" onClick={() => {this.pm.closePopup("quitter", "non")}}>Rester sur la page</button>
              <button className="oui" onClick={() => {this.pm.closePopup("quitter", "oui")}}>Quitter le jeu</button>
            </div>
        </div>
    )
  }
}

export default PopupQuitter;
